/* IZU Limited — one shared countdown (paused while the tab is hidden), vault type filter, add to bag through the theme's
   cart (izu:cart-open opens the drawer), quick add, and the inline Reserve choice. Vanilla, deferred, this template only. */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const pad = n => String(Math.max(0, n)).padStart(2, "0");

  // ---------- Countdown ----------
  const clocks = $$("[data-ltd-count]").map(el => ({ el, t: Date.parse(el.dataset.ltdCount) })).filter(c => !isNaN(c.t));
  let timer = null, announced = false;
  function tick() {
    const now = Date.now();
    clocks.forEach(({ el, t }) => {
      const left = Math.max(0, Math.floor((t - now) / 1000));
      const u = { d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60, s: left % 60 };
      Object.keys(u).forEach(k => { const n = el.querySelector(`[data-u="${k}"]`); if (n) n.textContent = pad(u[k]); });
      if (left === 0 && !el.dataset.done) {
        el.dataset.done = "1";
        if (el.dataset.ltdFormat === "line") el.textContent = "Opening now";
      }
    });
    if (clocks.length && clocks.every(c => c.t <= now)) {
      if (!announced) { announced = true; $$("[data-ltd-now]").forEach(n => { n.textContent = "Opening now"; }); }
      stop();
    }
  }
  function start() { if (!timer && clocks.length) { tick(); timer = setInterval(tick, 1000); } }
  function stop() { clearInterval(timer); timer = null; }
  document.addEventListener("visibilitychange", () => { document.hidden ? stop() : start(); });
  start();

  // ---------- Vault filter ----------
  const vault = document.querySelector("[data-ltd-vault]");
  if (vault) {
    const cards = $$("[data-ltd-card]", vault), nEl = vault.querySelector("[data-ltd-n]"), wEl = vault.querySelector("[data-ltd-word]");
    vault.addEventListener("click", e => {
      const chip = e.target.closest("[data-ltd-filter]");
      if (!chip) return;
      const f = chip.dataset.ltdFilter;
      $$("[data-ltd-filter]", vault).forEach(c => c.setAttribute("aria-pressed", String(c === chip)));
      let shown = 0;
      cards.forEach(c => { const on = f === "all" || c.dataset.type === f; c.hidden = !on; if (on) shown++; });
      if (nEl) nEl.textContent = pad(shown);
      if (wEl) wEl.textContent = shown === 1 ? "piece" : "pieces";
    });
  }

  // ---------- Cards: add to bag, quick add, reserve ----------
  document.addEventListener("click", e => {
    const card = e.target.closest("[data-ltd-card]");
    if (!card) return;

    const quick = e.target.closest("[data-ltd-quick]");
    if (quick) {
      const sel = card.querySelector("select[data-ltd-variant]");
      if (sel) { sel.focus(); sel.scrollIntoView({ block: "center", behavior: "smooth" }); }
      else card.querySelector("[data-ltd-add]")?.click();
      return;
    }

    const add = e.target.closest("[data-ltd-add]");
    if (add) {
      const id = card.querySelector("[data-ltd-variant]")?.value, msg = card.querySelector("[data-ltd-msg]");
      if (!id) return;
      add.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || "Could not add this piece."); }))
        .then(() => {
          add.textContent = "✓ In your bag";
          if (msg) msg.textContent = "";
          document.dispatchEvent(new CustomEvent("izu:cart-open"));
        })
        .catch(err => { if (msg) msg.textContent = err.message; add.disabled = false; });
      return;
    }

    const open = e.target.closest("[data-ltd-reserve-open]"), cancel = e.target.closest("[data-ltd-reserve-cancel]");
    if (open || cancel) {
      const box = card.querySelector("[data-ltd-reserve]"), panel = box.querySelector("[data-ltd-reserve-panel]"), btn = box.querySelector("[data-ltd-reserve-open]");
      const show = !!open;
      panel.hidden = !show;
      btn.hidden = show;
      btn.setAttribute("aria-expanded", String(show));
      (show ? panel.querySelector("a") : btn)?.focus();
    }
  });

  // Early-access form: after a post, focus the success or error message
  const f = document.querySelector("[data-ltd-focus]");
  if (f) { f.focus({ preventScroll: true }); document.getElementById("alerts")?.scrollIntoView({ block: "start" }); }
})();
